export default "__VITE_ASSET__c662de5a__"